import { setCalendarSidebarFilters } from '@common/reducers/CalendarReducer';
import { useAppDispatch, useAppSelector } from '@common/reducers/hooks/store.hook';
import { Campaign, Chat, Settings } from '@mui/icons-material';
import classes from './calendar-sidebar-filters.module.scss';

export default function CalendarSidebarFilters() {
    const filters = useAppSelector(state => state.CalendarReducer.calendarSidebarFilters);
    const dispatch = useAppDispatch();

    const toggleFilter = (filter) => {
        dispatch(setCalendarSidebarFilters({
            ...filters,
            [filter]: !filters[filter]
        }));
    };

    return (
        <div className={classes['filter-container']}>
            {/* Header - more subtle gradient and consistent with app's styling */}
            {/* <div style={{
                background: 'linear-gradient(90deg, #2B78D4 0%, #2AABEE 100%)',
                padding: '10px 14px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
            }}>
                <Settings sx={{ color: 'white', fontSize: 18 }} />
                <h3 style={{ 
                    fontSize: '13px', 
                    fontWeight: 500, 
                    color: 'white', 
                    margin: 0
                }}>
                    Display Options
                </h3>
            </div> */}

            {/* Filter Options */}
            <div style={{ padding: '8px 0' }}>
                {/* Messages Option */}
                <div style={{
                    padding: '6px 14px',
                    marginBottom: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                        <Chat sx={{ 
                            color: filters.showMessages ? '#2AABEE' : '#777', 
                            fontSize: 18, 
                            marginTop: '2px' 
                        }} />
                        <div>
                            <p style={{ 
                                margin: '0 0 2px 0', 
                                fontWeight: 500, 
                                fontSize: '13px', 
                                color: filters.showMessages ? '#2AABEE' : '#444'
                            }}>
                                Scheduled Messages
                            </p>
                            <p style={{ 
                                margin: 0, 
                                fontSize: '11px', 
                                color: '#777',
                                fontWeight: 400,
                                lineHeight: '1.2'
                            }}>
                                Display all upcoming scheduled messages
                            </p>
                        </div>
                    </div>
                    
                    {/* Toggle Switch - improved styling */}
                    <div 
                        className={classes['switch']} 
                        onClick={() => toggleFilter('showMessages')}
                        style={{
                            width: '36px',
                            height: '20px',
                            position: 'relative',
                            backgroundColor: filters.showMessages ? '#2AABEE' : '#ddd',
                            borderRadius: '20px',
                            transition: 'background-color 0.2s',
                            cursor: 'pointer',
                            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)'
                        }}
                    >
                        <div style={{
                            position: 'absolute',
                            height: '16px',
                            width: '16px',
                            left: filters.showMessages ? '17px' : '3px',
                            top: '2px',
                            backgroundColor: 'white',
                            transition: 'left 0.2s',
                            borderRadius: '50%',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
                        }}></div>
                    </div>
                </div>

                {/* Faint divider */}
                <div style={{ 
                    height: '1px', 
                    margin: '4px 14px', 
                    backgroundColor: 'rgba(0,0,0,0.05)' 
                }}></div>

                {/* Campaigns Option */}
                <div style={{
                    padding: '6px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                        <Campaign sx={{ 
                            color: filters.showCampaigns ? '#2AABEE' : '#777', 
                            fontSize: 18, 
                            marginTop: '2px' 
                        }} />
                        <div>
                            <p style={{ 
                                margin: '0 0 2px 0', 
                                fontWeight: 500, 
                                fontSize: '13px', 
                                color: filters.showCampaigns ? '#2AABEE' : '#444'
                            }}>
                                Scheduled Campaigns
                            </p>
                            <p style={{ 
                                margin: 0, 
                                fontSize: '11px', 
                                color: '#777',
                                fontWeight: 400,
                                lineHeight: '1.2'
                            }}>
                                Show all active and upcoming campaigns
                            </p>
                        </div>
                    </div>
                    
                    {/* Toggle Switch - consistent with above */}
                    <div 
                        className={classes['switch']} 
                        onClick={() => toggleFilter('showCampaigns')}
                        style={{
                            width: '36px',
                            height: '20px',
                            position: 'relative',
                            backgroundColor: filters.showCampaigns ? '#2AABEE' : '#ddd',
                            borderRadius: '20px',
                            transition: 'background-color 0.2s',
                            cursor: 'pointer',
                            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)'
                        }}
                    >
                        <div style={{
                            position: 'absolute',
                            height: '16px',
                            width: '16px',
                            left: filters.showCampaigns ? '17px' : '3px',
                            top: '2px',
                            backgroundColor: 'white',
                            transition: 'left 0.2s',
                            borderRadius: '50%',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
                        }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}